<template>
    
</template>

<script>
    export default {
        name: "Reasons"
    }
</script>

<style scoped>

</style>